import React, { createContext, PropsWithChildren, useCallback } from 'react';
import { type Id, toast, ToastContainer } from 'react-toastify';
import { ToastMessage, type ToastMessageProps } from '../../components';

interface ToastContextProps {
  success: (_title: string, _message: string) => Id;
  error: (_title: string, _message: string) => Id;
}

// eslint-disable-next-line react-refresh/only-export-components
export const ToastContext = createContext<ToastContextProps>({
  success: () => '',
  error: () => '',
});

const toaster = (props: ToastMessageProps, toastProps: object): Id => {
  const toastId = toast(
    () => <ToastMessage {...props} onClose={() => toast.dismiss(toastId)} />,
    toastProps
  );
  return toastId;
};

const ToastProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const success = useCallback(
    (title: string, message: string) =>
      toaster({ title, message, type: 'success' }, {}),
    []
  );

  const error = useCallback(
    (title: string, message: string) =>
      toaster({ title, message, type: 'error' }, {}),
    []
  );

  return (
    <ToastContext.Provider
      value={{
        success,
        error,
      }}
    >
      {children}
      <ToastContainer
        hideProgressBar
        autoClose={5000}
        closeButton={false}
        style={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          border: 'none',
        }}
      />
    </ToastContext.Provider>
  );
};

export default ToastProvider;
